import { ChevronLeftIcon } from "../icons/ChevronLeftIcon";

type BackButtonProps = {
  onClick: () => void;
};

export const BackButton = ({ onClick }: BackButtonProps) => (
  <button
    type="button"
    className="-ml-3 mb-2 inline-flex min-h-12 min-w-12 cursor-pointer items-center gap-1 rounded-lg border-none bg-transparent px-3 py-3 font-medium text-ocean-600 text-sm transition-colors hover:bg-ocean-50 hover:text-ocean-800 active:bg-ocean-100"
    onClick={onClick}
  >
    <ChevronLeftIcon />
    戻る
  </button>
);
